module.exports = __webpack_public_path__ + "static/media/ciel-paris-d.5d76ac54.png";